<template>
	<transition name="fade">
		<div class="processar" style="z-index: 99999999999" v-show="exibir">
			<div class="processar-center">
				<small style="color: white">{{ text.toUpperCase() }}...</small><br />
				<br />
				<spinner style="width: 50px; height: 50px" />
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	data() {
		return {
			exibir: false,
			text: ''
		}
	},

	mounted() {
		bus.$on('load-in', (obj) => {
			this.exibir = true
			if (!_.isNil(obj.text)) {
				this.text = obj.text
			}
		})

		bus.$on('load-out', () => {
			this.exibir = false
		})
	}
}
</script>

<style>
.processar {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0.9;
	background-color: #000;
	z-index: 9999999999999;
}

.processar-center {
	top: 36%;
	left: 0;
	right: 0;
	position: absolute;
	color: #fff;
	text-align: center;
	z-index: 9999999999999;
}
</style>
